import { REQUIRED_OBJECT_VALIDATOR, REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { OrganizationType } from '../../types/types';
import { SUBSCRIPTION_PLAN_TYPE_OPTIONS } from '../CreateOrganizationForm/const';
import { BILLING_SUBSCRIPTION_STATUS, SUBSCRIPTION_PLAN_TYPE } from '@/const/shared';
import { OpcoOrganizationDetailsType } from '@/api/v1/opco/organizations/getOrganizationApi';
import { boolean, object } from 'yup';

export const EDIT_ORGANIZATION_VALIDATION_SCHEMA = object().shape({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
  subscription_plan_type: REQUIRED_OBJECT_VALIDATOR,
  is_kyc_allowed: boolean(),
  is_api_keys_allowed: boolean(),
});

export const getEditOrganizationInitialValues = (organizationDetails: OrganizationType) => {
  const selectedPlanType = SUBSCRIPTION_PLAN_TYPE_OPTIONS.find(
    (option) => option.value === organizationDetails?.subscription_plan_type
  );

  return {
    name: organizationDetails?.name || '',
    subscription_plan_type: selectedPlanType,
    is_kyc_allowed: !!organizationDetails?.is_kyc_allowed,
    is_api_keys_allowed: !!organizationDetails?.is_api_keys_allowed,
  };
};

export const getIsAllowedToChangePlan = (organizationDetails: OpcoOrganizationDetailsType) => {
  if (!organizationDetails) return;

  const { subscription_plan_type, billing_profile } = organizationDetails;
  const isStandardPlan = subscription_plan_type === SUBSCRIPTION_PLAN_TYPE.STANDARD;
  const isCancelledSubscription = billing_profile?.subscription?.status === BILLING_SUBSCRIPTION_STATUS.CANCELLED;

  return isStandardPlan && (isCancelledSubscription || !billing_profile);
};
